<!-- 车主管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(1, 'owner', '')" v-if="permission.addCarOwner">{{
                    permission.addCarOwner
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">车主名称</div>
                <el-autocomplete class="search-item" v-model="searchData.Name" :fetch-suggestions="querySearch" placeholder="车主名称" size="small"></el-autocomplete>
                <div class="search-name">手机号码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.CallNum" placeholder="手机号码"></el-input>
                <div class="search-name">车牌号码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.PlateNum" placeholder="车牌号码"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                row-key="id"
                border=""
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
                <el-table-column width="200px" prop="Name" label="车主名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="150px" prop="PhoneNum" label="手机号" show-overflow-tooltip></el-table-column>
                <el-table-column width="150px" prop="CarNum" label="车牌号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CarDesc" label="车型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="VehicleCode" label="车架号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="EngineNum" label="发动机号" show-overflow-tooltip></el-table-column>
                <el-table-column width="160px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.addCar && !scope.row.IsChild" title="添加车辆" size="mini" type="text" @click="add(1, 'car', scope.row)">{{
                                permission.addCar
                            }}</el-button>
                            <el-button v-if="permission.editCarOwner && !scope.row.IsChild" title="编辑车主" size="mini" type="text" @click="add(2, 'owner', scope.row)">{{
                                permission.editCarOwner
                            }}</el-button>
                            <el-button v-if="permission.delCarOwner && !scope.row.IsChild" title="删除车主" size="mini" type="text" @click="del(scope.row)">{{
                                permission.delCarOwner
                            }}</el-button>
                            <el-button v-if="permission.editCar && scope.row.IsChild" title="编辑车辆" size="mini" type="text" @click="add(2, 'car', scope.row)">{{
                                permission.editCar
                            }}</el-button>
                            <el-button v-if="permission.delCar && scope.row.IsChild" title="删除车辆" size="mini" type="text" @click="delCar(scope.row)">{{
                                permission.delCar
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <carOwnerEdit ref="customerEdit" :obj="obj" :type="dialogType" :carOwnerData="carOwnerData" @closeDialog="closeDialog"></carOwnerEdit>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import carOwnerEdit from '@/components/business/repairMamage/carOwnerEdit';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        carOwnerEdit,
        breadcrumb,
        elTableColumn
    },
    data() {
        let curr_user = this.$util.getLocalStorage('userMsg');
        return {
            curr_user: curr_user,
            cId: '',
            dialogVisible: false,
            searchData: {
                EntpId: curr_user.EntpId,
                Name: '',
                PhoneNum: '',
                PlateNum: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            dialogTitle: '',
            dialogType: -1,
            obj: '',
            carOwnerData: {}
        };
    },
    created() {
        this.getTableData();
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('CarOwnerMamage');
    },
    methods: {
        resetSearch() {
            this.searchData = {
                EntpId: this.curr_user.EntpId,
                Name: '',
                PhoneNum: '',
                PlateNum: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/GetCarOwnerList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.add(3, 'car', event);
            }
        },
        querySearch(queryString, cb) {
            this.$util.searchCarOwners(queryString).then(data => {
                let customerList = [];
                for (let i in data) {
                    customerList.push({
                        value: data[i].Name
                    });
                }
                cb(customerList);
            });
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        add(type, obj, carOwnerData) {
            this.obj = obj;
            this.dialogType = type;
            this.carOwnerData = carOwnerData;
            let objName = obj == 'owner' ? '车主' : '车辆';
            switch (type) {
                case 1:
                    this.dialogTitle = '新增' + objName;
                    break;
                case 2:
                    this.dialogTitle = '编辑' + objName;
                    break;
                case 3:
                    this.dialogTitle = objName + '信息';
                    break;
            }
            this.dialogVisible = true;
        },

        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该车主吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/CustomerManagement/DelCarOwner?cid=${row.CId}`
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        delCar(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该车辆吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/CustomerManagement/DelCar',
                            data: {
                                carId: row.CarId,
                                entpId: that.curr_user.EntpId
                            }
                        })
                        .then(resp => {
                            if (resp.data.errcode == 0) {
                                that.searchData.page = 1;
                                that.$util.successMsg('删除成功');
                                that.getTableData();
                            } else {
                                that.$util.errorMsg(resp.data.errmsg);
                            }
                        })
                        .catch(() => {});
                }
            });
        }
    }
};
</script>
